import { render, staticRenderFns } from "./logout-redirect.vue?vue&type=template&id=718a3853&"
import script from "./logout-redirect.vue?vue&type=script&lang=js&"
export * from "./logout-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports